import { Injectable } from "@angular/core";
import { Router, CanActivate } from "@angular/router";

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router) { }

    canActivate() {
        if (localStorage.getItem("UserValues") != null) {
            return true;
        } else {
            this.router.navigate(['/login-module']);
            return false;
        }
    }
    canActivateChild() {
        if (localStorage.getItem("SECRETCODE_TOOL") != null) {
            return true;
        } else {
            this.router.navigate(['/master']);
            return false;
        }
    }
}


// WEBPACK FOOTER //
// D:/Venkat Projects/sagiam-tool-angular/src/app/auth.guard.ts